import { Serializable } from "./serializable";

export default class Product implements Serializable<Product> {
  id?: string;
  title?: string;
  description?: string;
  images?: any[];
  cover?: string;
  wineType?: string;
  vine?: string;
  alcoholicDegree?: string;
  serviceTemperature?: string;
  color?: string;
  smell?: string;
  taste?: string;
  pairing?: string;
  cardLink: string = "product";
  cardType: string = "productCard";
  priority?: number = 0;

  deserialize(input: any): Product {
    if (input != null) {
      this.id = input.id;
      this.title = input.name || "";
      this.description = input.description || "";
      if (input.photos && input.photos.length > 0) {
        this.images =
          input.photos.map((item: any) => {
            if (item.cover) this.cover = item.urls.p || null;
            if (item.urls) return item.urls.p;
          }) || [];
        if (!this.cover && input.photos[0].urls)
          this.cover = input.photos[0].urls.p;
      }
      this.wineType = input.wine_type || "";
      this.vine = input.vine || "";
      this.alcoholicDegree = input.alcoholic_degree || "";
      this.serviceTemperature = input.service_temperature || "";
      this.color = input.color || "";
      this.smell = input.smell || "";
      this.taste = input.taste || "";
      this.pairing = input.pairing || "";
      this.priority = input.priority || null;
    }
    return this;
  }
}
